import { useContext } from "react";
import { ArrowDown, ArrowUp, Copy, Pencil, Plus, Trash2 } from "lucide-react";
import { EditCtx } from "./SiteParts";

const TB = "w-7 h-7 rounded-full bg-white text-[#062a20] shadow flex items-center justify-center hover:bg-[#f4efe2] disabled:opacity-30";

function Toolbar({ id, ed }) {
  const act = (fn) => (e) => { e.stopPropagation(); e.preventDefault(); fn(); };
  return (
    <div data-ez-tb className="absolute top-2 right-2 z-40 flex gap-1 opacity-100 md:opacity-0 md:group-hover/ez:opacity-100 focus-within:opacity-100 transition-opacity" data-testid={`edit-toolbar-${id}`}>
      <button className={TB} title="Edit" onClick={act(() => ed.open({ kind: "section", id }))} data-testid={`edit-section-${id}`}><Pencil className="w-3.5 h-3.5" /></button>
      <button className={TB} title="Move up" onClick={act(() => ed.move(id, -1))} data-testid={`move-up-${id}`}><ArrowUp className="w-3.5 h-3.5" /></button>
      <button className={TB} title="Move down" onClick={act(() => ed.move(id, 1))} data-testid={`move-down-${id}`}><ArrowDown className="w-3.5 h-3.5" /></button>
      <button className={TB} title="Duplicate" onClick={act(() => ed.duplicate(id))} data-testid={`duplicate-${id}`}><Copy className="w-3.5 h-3.5" /></button>
      <button className={TB} title="Add a section below" onClick={act(() => ed.addAfter(id))} data-testid={`add-after-${id}`}><Plus className="w-3.5 h-3.5" /></button>
      <button className={`${TB} !text-red-700`} title="Remove section" onClick={act(() => ed.remove(id))} data-testid={`remove-section-${id}`}><Trash2 className="w-3.5 h-3.5" /></button>
    </div>);
}

export function EditZone({ target, children, label }) {
  const ed = useContext(EditCtx);
  if (!ed) return children;
  const open = (e) => { if (e.target.closest("[data-ez-tb]") || e.target.closest("[data-et]")) return; e.preventDefault(); e.stopPropagation(); ed.open(target); };
  return (
    <div className="relative group/ez cursor-pointer outline-2 outline-offset-[-2px] hover:outline-dashed hover:outline-[#b8892b]" onClickCapture={open} data-testid={`edit-zone-${target.id || target.kind}`}>
      <span className="absolute bottom-2 left-2 z-40 text-[10px] font-semibold uppercase tracking-wider bg-[#b8892b] text-white px-2 py-0.5 rounded opacity-0 group-hover/ez:opacity-100 pointer-events-none">Click to edit {label}</span>
      {target.kind === "section" && <Toolbar id={target.id} ed={ed} />}
      {children}
    </div>);
}
